import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Grid } from "semantic-ui-react";
import { ADMIN_DASHBOARD_PATH } from "../../api/routeConstants";
import { useHistory } from "react-router-dom";
import { logErrorInFirestore } from "../../firestore/firestoreService";
import logo from "../../../assets/icons/logo-transparent.svg";

export default function ErrorOverlay() {
  const history = useHistory();

  document.title = "Error Occurred | Hello Radius";

  const { appError } = useSelector((state) => state.app);
  const { prevLocation } = useSelector((state) => state.navigation);

  useEffect(() => {
    if (!prevLocation && !appError) return;

    async function sendError() {
      await logErrorInFirestore({
        error: appError,
        errorPage: prevLocation?.pathname ? prevLocation.pathname : "no prev",
      });
    }

    try {
      sendError().then(() => console.log("error overlay - error logged"));
    } catch (e) {
      console.log(e);
    }
  }, [appError, prevLocation]);

  function handleResetToHome() {
    history.push(ADMIN_DASHBOARD_PATH);
    window.location.reload();
  }

  return (
    <Grid container textAlign="left" style={{ height: "80vh" }}>
      <Grid.Row centered>
        <Grid.Column computer={10} mobile={15} verticalAlign={"middle"}>
          <div className="display-flex justify-center">
            <img src={logo} alt="hello radius logo" />
          </div>
          <div style={{ marginTop: 30 }}>
            <div className="title-normal">Something unexpected happened…</div>
            <div
              className="body-blue-text"
              style={{ margin: "37px 0", width: "85%" }}
            >
              We're investigating the problem. Please try again or contact our
              team at info@helloradius.com.
            </div>
          </div>
          <Button
            className={"overwrite-button cta-orange-form"}
            content={"Reload dashboard"}
            onClick={handleResetToHome}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
